﻿<template>
    <div class="notice-export">
        <div class="search-box">
            <el-input 
                v-model="CurSearch" 
                placeholder="请输入考生号/姓名/证件号码" 
                clearable
                @keyup.enter.native="OnSearch(2)"
                style="width: 350px;">
                <i slot="prefix" class="el-icon-search"></i>
            </el-input>
            <el-button type="primary" icon="el-icon-search" @click="OnSearch(2)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="OnSearch(1)">重置</el-button>
            <el-button type="warning" icon="el-icon-files" @click="showDownloadDialog" :disabled="selectedCount === 0">
                导出通知书({{ selectedCount }})
            </el-button>
            <el-button type="primary" icon="el-icon-printer" @click="handlePrint" :disabled="selectedCount === 0" :loading="printLoading">
                打印通知书({{ selectedCount }})
            </el-button>
        </div>

        <div class="data-table">
            <el-table 
                ref="dataTable"
                :data="List" 
                :row-key="row => row.G_SN"
                border 
                stripe
                style="width: 100%"
                :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                empty-text="暂无数据">
                
                <el-table-column width="50" align="center">
                    <template slot="header">
                        <el-checkbox :value="isAllSelected" @change="toggleSelectAll"></el-checkbox>
                    </template>
                    <template slot-scope="scope">
                        <el-checkbox :value="isRowSelected(scope.row.G_SN)" @change="toggleRowSelect(scope.row)"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column prop="KSH" label="考生号" align="center"></el-table-column>
                <el-table-column prop="XM" label="姓名" align="center"></el-table-column>
                <el-table-column prop="G_XYMC" label="学院" align="center" show-overflow-tooltip>
                    <template slot="header">
                        <span>学院</span>
                        <table-column-filter field="G_XYMC" :options="getFilters('G_XYMC')" :value="activeFilters['G_XYMC']" @filter-change="handleCustomFilter" />
                    </template>
                </el-table-column>
                <el-table-column prop="LQZYMC" label="专业名称" align="center" show-overflow-tooltip>
                    <template slot="header">
                        <span>专业名称</span>
                        <table-column-filter field="LQZYMC" :options="getFilters('LQZYMC')" :value="activeFilters['LQZYMC']" @filter-change="handleCustomFilter" />
                    </template>
                </el-table-column>
                <el-table-column prop="G_Sheng" label="省份" align="center">
                    <template slot="header">
                        <span>省份</span>
                        <table-column-filter field="G_Sheng" :options="getFilters('G_Sheng')" :value="activeFilters['G_Sheng']" @filter-change="handleCustomFilter" />
                    </template>
                </el-table-column>
                <el-table-column label="录取号" align="center">
                    <template slot-scope="scope">
                        {{ formatBH(scope.row.BH) }}
                    </template>
                </el-table-column>
                <el-table-column prop="PCMC" label="批次" align="center">
                    <template slot="header">
                        <span>批次</span>
                        <table-column-filter field="PCMC" :options="getFilters('PCMC')" :value="activeFilters['PCMC']" @filter-change="handleCustomFilter" />
                    </template>
                </el-table-column>
                <el-table-column label="是否打印通知书" width="150" align="center">
                    <template slot="header">
                        <span>是否打印通知书</span>
                        <table-column-filter field="PrintStatus" :options="getFilters('PrintStatus')" :value="activeFilters['PrintStatus']" @filter-change="handleCustomFilter" />
                    </template>
                    <template slot-scope="scope">
                        <el-tag v-if="isPrinted(scope.row.G_SN)" type="success" size="small">是</el-tag>
                        <el-tag v-else type="warning" size="small">否</el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="PageInfo.CurPage"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="PageInfo.RecordCountOfPage"
                layout="total, sizes, prev, pager, next, jumper"
                :total="PageInfo.RecordCount">
            </el-pagination>
        </div>

        <el-dialog title="导出通知书" :visible.sync="downloadDialogVisible" width="600px">
            <el-form :model="downloadForm" label-width="120px">
                <el-form-item label="文件命名">
                    <el-checkbox-group v-model="downloadForm.fileNameType">
                        <el-checkbox :label="1">省份</el-checkbox>
                        <el-checkbox :label="2">学院</el-checkbox>
                        <el-checkbox :label="4">专业</el-checkbox>
                        <el-checkbox :label="64">批次</el-checkbox>
                        <el-checkbox :label="8">考生号</el-checkbox>
                        <el-checkbox :label="16">录取号</el-checkbox>
                        <el-checkbox :label="32">姓名</el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item label="任务标题" required>
                    <el-input v-model="downloadForm.title" placeholder="请输入任务标题（10字以内）" maxlength="10" show-word-limit></el-input>
                </el-form-item>
                <el-form-item>
                    <el-alert title="生成规则说明" type="info" :closable="false">
                        <div>1. 将根据勾选的考生生成通知书文件</div>
                        <div>2. 当前已选择 {{ selectedCount }} 名考生</div>
                        <div>3. 文件将在后台生成，请前往"通知书下载"页面查看</div>
                        <div>4. 文件命名将按照勾选的顺序组合</div>
                    </el-alert>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleDownloadConfirm" :loading="downloadLoading">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import TableColumnFilter from '../Shared/TableColumnFilter.vue';

    export default {
        name: 'NoticeExport',
        components: {
            TableColumnFilter
        },
        data: function () {
            return {
                CurSearch: '',
                List: [],
                selectedSNs: [],
                excludedSNs: [],
                isAllSelected: false,
                PageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1,
                    RecordCountOfPage: 20
                },
                downloadDialogVisible: false,
                downloadLoading: false,
                downloadForm: {
                    fileNameType: [],
                    title: ''
                },
                activeFilters: {
                    G_XYMC: [],
                    LQZYMC: [],
                    G_Sheng: [],
                    PCMC: [],
                    PrintStatus: []
                },
                allFilters: {},
                printedSNs: [],
                printLoading: false
            }
        },
        computed: {
            selectedCount: function () {
                if (this.isAllSelected) {
                    return this.PageInfo.RecordCount - this.excludedSNs.length;
                }
                return this.selectedSNs.length;
            }
        },
        methods: {
            formatBH(bh) {
                if (!bh) return '';
                var bhStr = String(bh);
                if (bhStr.indexOf('.') > 0) {
                    bhStr = bhStr.split('.')[0];
                }
                if (bhStr.length !== 10) return bhStr;
                var prefix = bhStr.substring(0, 2);
                var year = bhStr.substring(2, 6);
                var seq = bhStr.substring(6);
                var typePrefix = '';
                switch (prefix) {
                    case '11': typePrefix = 'BK'; break;
                    case '22': typePrefix = 'ZK'; break;
                    case '33': typePrefix = 'ZD'; break;
                    default: return bhStr;
                }
                return typePrefix + year + seq;
            },
            getFilters(prop) {
                if (prop === 'PrintStatus') {
                    return [
                        { text: '是', value: '是' },
                        { text: '否', value: '否' }
                    ];
                }
                if (this.allFilters[prop]) {
                    return this.allFilters[prop];
                }
                return [];
            },
            handleCustomFilter({ field, values }) {
                var that = this;
                if (values && values.length > 0) {
                    that.$set(that.activeFilters, field, values);
                } else {
                    that.$delete(that.activeFilters, field);
                }
                that.selectedSNs = [];
                that.excludedSNs = [];
                that.isAllSelected = false;
                that.LoadList(1);
            },
            OnSearch: function (type) {
                var that = this;
                if (type == 1) {
                    that.CurSearch = '';
                    that.$set(that.activeFilters, 'G_XYMC', []);
                    that.$set(that.activeFilters, 'LQZYMC', []);
                    that.$set(that.activeFilters, 'G_Sheng', []);
                    that.$set(that.activeFilters, 'PCMC', []);
                    that.$set(that.activeFilters, 'PrintStatus', []);
                }
                that.selectedSNs = [];
                that.excludedSNs = [];
                that.isAllSelected = false;
                that.LoadList();
            },
            handleSizeChange(val) {
                this.selectedSNs = [];
                this.excludedSNs = [];
                this.isAllSelected = false;
                this.LoadList(1, val);
            },
            handleCurrentChange(val) {
                this.LoadList(val, this.PageInfo.RecordCountOfPage);
            },
            isRowSelected: function (sn) {
                if (this.isAllSelected) {
                    return this.excludedSNs.indexOf(sn) === -1;
                }
                return this.selectedSNs.indexOf(sn) !== -1;
            },
            toggleSelectAll: function (val) {
                var that = this;
                that.isAllSelected = val;
                that.excludedSNs = [];
                that.selectedSNs = [];
            },
            toggleRowSelect: function (row) {
                var that = this;
                var sn = row.G_SN;
                var idx;
                if (that.isAllSelected) {
                    idx = that.excludedSNs.indexOf(sn);
                    if (idx !== -1) {
                        that.excludedSNs.splice(idx, 1);
                    } else {
                        that.excludedSNs.push(sn);
                    }
                } else {
                    idx = that.selectedSNs.indexOf(sn);
                    if (idx !== -1) {
                        that.selectedSNs.splice(idx, 1);
                    } else {
                        that.selectedSNs.push(sn);
                    }
                }
            },
            isPrinted: function (sn) {
                return this.printedSNs.indexOf(sn) !== -1;
            },
            loadPrintedStatus: function () {
                var that = this;
                var api_name = '/Notice/GetPrintedSNs';
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Env.GetApiUrl(api_name), { loading_msg: '' })
                    .then(result => {
                        if (result.data) {
                            that.printedSNs = result.data || [];
                        }
                    }).catch(() => { });
            },
            LoadList: function (pageIdx, pageCount) {
                var that = this;
                var api_name = '/Notice/GetStudentList';
                var url = TYBM_Env.GetApiUrl(api_name) + 
                    '?Search=' + encodeURIComponent(that.CurSearch || '');
                
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        url += '&Filter_' + key + '=' + encodeURIComponent(values.join(','));
                    }
                });
                
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, pageIdx, pageCount), { loading_msg: '正在加载数据' })
                    .then(result => {
                        that.PageInfo = result.data.PageInfo;
                        var rawList = result.data.List;
                        
                        if (that.activeFilters['PrintStatus'] && that.activeFilters['PrintStatus'].length > 0) {
                            rawList = rawList.filter(row => {
                                var isPrinted = that.isPrinted(row.G_SN);
                                var statusText = isPrinted ? '是' : '否';
                                return that.activeFilters['PrintStatus'].indexOf(statusText) !== -1;
                            });
                        }
                        
                        that.List = rawList;
                        
                        if (result.data.AllFilters) {
                            that.allFilters = result.data.AllFilters;
                        }

                    }).catch(() => { });
            },
            showDownloadDialog: function () {
                var that = this;
                if (that.selectedCount === 0) {
                    that.$message.warning('请先勾选要导出的考生');
                    return;
                }
                that.downloadForm.title = '';
                that.downloadForm.fileNameType = [];
                that.downloadDialogVisible = true;
            },
            handleDownloadConfirm: function () {
                var that = this;
                
                if (that.downloadForm.fileNameType.length === 0) {
                    that.$message.warning('请至少选择一个文件命名规则');
                    return;
                }
                
                if (!that.downloadForm.title || that.downloadForm.title.trim() === '') {
                    that.$message.warning('请输入任务标题');
                    return;
                }
                
                if (that.downloadForm.title.length > 10) {
                    that.$message.warning('任务标题不能超过10个字');
                    return;
                }
                
                var fileNameTypeValue = that.downloadForm.fileNameType.reduce(function(sum, val) { return sum + val; }, 0);
                
                var filters = {};
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        filters[key] = values.join(',');
                    }
                });
                
                that.downloadLoading = true;
                var api_name = '/Notice/DownloadNoticePDF';
                var url = TYBM_Env.GetApiUrl(api_name);
                
                var payload = {
                    FileNameType: fileNameTypeValue,
                    Title: that.downloadForm.title,
                    Search: that.CurSearch || '',
                    Filters: filters,
                    SelectedSNs: that.isAllSelected ? null : that.selectedSNs,
                    ExcludedSNs: that.isAllSelected ? that.excludedSNs : null
                };
                
                TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify(payload) }, { loading_msg: '正在创建任务...', has_progress: false })
                    .then(function(res) {
                        if (res.code === 'ok') {
                            that.$message.success('任务已创建，文件正在后台生成，请前往"通知书下载"页面查看');
                            that.downloadDialogVisible = false;
                        } else {
                            that.$message.error(res.errmsg || res.msg || '创建任务失败');
                        }
                    })
                    .catch(function() {
                        that.$message.error('创建任务失败');
                    })
                    .finally(function() {
                        that.downloadLoading = false;
                    });
            },
            handlePrint: function () {
                var that = this;
                
                if (that.selectedCount === 0) {
                    that.$message.warning('请先勾选要打印的考生');
                    return;
                }
                
                var filters = {};
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        filters[key] = values.join(',');
                    }
                });
                
                var printUrl = TYBM_Env.GetApiUrl('/Notice/PrintNotice') + '?search=' + encodeURIComponent(that.CurSearch || '') + '&filters=' + encodeURIComponent(JSON.stringify(filters)) + '&selectedSNs=' + (that.isAllSelected ? '' : that.selectedSNs.join(',')) + '&excludedSNs=' + (that.isAllSelected ? that.excludedSNs.join(',') : '');
                var printWindow = window.open(printUrl, '_blank');
                
                if (!printWindow) {
                    that.$message.warning('请允许弹出窗口以进行打印');
                    return;
                }
                
                // 监听打印窗口关闭事件，刷新打印状态
                var checkClose = setInterval(function() {
                    if (printWindow.closed) {
                        clearInterval(checkClose);
                        that.loadPrintedStatus();
                    }
                }, 1000);
            }
        },
        created: function () {
            this.loadPrintedStatus();
            this.LoadList();
        }
    }
</script>

<style scoped>
    .notice-export {
        width: 100%;
    }

    .search-box {
        display: flex;
        gap: 12px;
        margin-bottom: 20px;
        align-items: center;
        flex-wrap: wrap;
    }

    .data-table {
        background: white;
        border-radius: 8px;
        overflow-x: auto;
    }

    .data-table >>> .el-table {
        font-size: 13px;
    }

    .data-table >>> .el-table th,
    .data-table >>> .el-table td {
        padding: 0 !important;
        height: 40px !important;
    }

    .data-table >>> .el-table th {
        background-color: #f5f7fa !important;
        color: #606266 !important;
        font-weight: 600;
    }

    .data-table >>> .el-table__row {
        height: 40px !important;
    }

    .data-table >>> .el-table__row:hover {
        background-color: #f5f9ff;
    }

    .data-table >>> .el-table .cell {
        padding: 0 8px !important;
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        line-height: 40px !important;
    }

    .data-table >>> .el-table th > .cell {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 100% !important;
        line-height: normal !important;
    }

    .pagination-container {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
</style>